<template>
  <button @click="show" :aria-label="$t('buttons.move')" :title="$t('buttons.move')" class="action" id="move-button">
    <corner-up-right-icon size="1.5x" class="custom-class"></corner-up-right-icon>
    <span>{{ $t('buttons.move') }}</span>
  </button>
</template>

<script>

import { CornerUpRightIcon } from 'vue-feather-icons';

export default {
  name: 'move-button',
  components: {
    CornerUpRightIcon
  },
  methods: {
    show: function () {
      this.$store.commit('showHover', 'move');
    }
  }
};
</script>
